import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { comparison } from '../constants/data';
export function ComparisonTable() {
  return <section className="w-full px-5 py-16 sm:py-24" style={{
    backgroundColor: '#0A0A0A'
  }} data-id="element-34">
      <div className="mx-auto max-w-4xl" data-id="element-35">
        <Reveal data-id="element-36">
          <h2 className="text-center text-2xl sm:text-3xl lg:text-4xl font-bold" data-id="element-37">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-38">
          <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-39">
            {/* Sin Megapack */}
            <div className="glass overflow-hidden" data-id="element-40">
              <div className="flex items-center gap-2 px-5 py-3 font-bold" style={{
              backgroundColor: 'rgba(255,59,48,0.15)',
              color: '#FF3B30'
            }} data-id="element-41">
                <XIcon className="w-5 h-5" strokeWidth={3} aria-hidden="true" data-id="element-42" />
                Sin Megapack
              </div>
              <ul data-id="element-43">
                {comparison.map((row, i) => <li key={row.without} className="px-5 py-3 text-sm text-white/75" style={{
                backgroundColor: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.02)'
              }} data-id="element-44">
                    {row.without}
                  </li>)}
              </ul>
            </div>

            {/* Con Megapack */}
            <div className="glass overflow-hidden" data-id="element-45">
              <div className="flex items-center gap-2 px-5 py-3 font-bold" style={{
              backgroundColor: 'rgba(0,200,83,0.15)',
              color: '#00C853'
            }} data-id="element-46">
                <CheckIcon className="w-5 h-5" strokeWidth={3} aria-hidden="true" data-id="element-47" />
                Con Megapack
              </div>
              <ul data-id="element-48">
                {comparison.map((row, i) => <li key={row.with} className="px-5 py-3 text-sm text-white/85" style={{
                backgroundColor: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.02)'
              }} data-id="element-49">
                    {row.with}
                  </li>)}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}